<template>
  <div class="usage">
    <van-row>
      <van-col class="title" :span="24">使用方法</van-col>
      <van-col v-if="usageRemarkArrayemark.length">
        <div class="content">
          <p
            class="usageList"
            v-for="(item, index) in usageRemarkArrayemark"
            :key="item.id"
          >
            {{ index + 1 }} {{ item }}
          </p>
        </div>
      </van-col>
      <van-empty v-else class="van-empty" description="暂无使用方法" />
    </van-row>
    <van-row>
      <van-col class="title" :span="24">配置说明</van-col>
      <van-col v-if="configRemarkArray.length">
        <div class="content">
          <p
            class="usageList"
            v-for="(item, index) in configRemarkArray"
            :key="item.id"
          >
            {{ item }}
          </p>
        </div>
      </van-col>
      <van-empty v-else class="van-empty" description="暂无配置说明" />
    </van-row>
    <van-row>
      <van-col class="title" :span="24">配置方法</van-col>
      <div v-if="planList.length" class="configContainer">
        <div v-for="plan in planList" :key="plan.id">
          <ul>
            <li>
              <van-sidebar v-model="activeKey">
                <van-sidebar-item
                  :title="
                    '时间 ' + plan.usageTime + ' 温水' + plan.water + 'ml'
                  "
                ></van-sidebar-item>
              </van-sidebar>

              <table class="table">
                <thead align="left">
                  <tr>
                    <th>项目名称</th>
                    <th>用量</th>
                    <!-- <th>温水</th> -->
                  </tr>
                  <tr v-for="item in plan.list" :key="item.id">
                    <td>{{ item.productName }}</td>
                    <td>{{ item.configNum + item.configUnit }}</td>
                    <!-- <td>{{ plan.water }}ml</td> -->
                  </tr>
                </thead>
              </table>
            </li>
          </ul>
        </div>
      </div>
      <van-empty v-else class="van-empty" description="暂无配置说明" />
      <!-- <div>
      <p>配置说明</p>
      <div>
        
      </div>
    </div> -->
    </van-row>
  </div>
</template>
<script>
import { requestPrescriptionUsage } from "@/api/prescription/prescription";
import { useRoute, useRouter } from "vue-router";
export default {
  data() {
    return {
      usageRemarkArrayemark: [],
      configRemarkArray: [],
      planList: [],
      
    };
  },
  created() {
    this.getPrescriptionInfo();
  },
  methods: {
    getPrescriptionInfo() {
      const id = useRoute().query.id;
      requestPrescriptionUsage({ id }).then((v) => {
        const { usageRemarkArrayemark, configRemarkArray, planList } = v.data;
        this.usageRemarkArrayemark = usageRemarkArrayemark;
        this.configRemarkArray = configRemarkArray;
        this.planList = planList;
        console.log(v);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.usage {
  .van-empty {
    margin: 0 auto;
    padding: 10px 0;
  }
  .content {
    padding: 10px;
    .usageList {
      line-height: 30px;
    }
  }
  .configContainer {
    width: 100%;
    @extend .content;
    .table {
      width: 100%;
      border-collapse: collapse;
      td {
        padding: 10px;
        border-bottom: 1px solid var(--basic-border-color);
        &:nth-of-type(2) {
          width: 30%;
          text-align: right;
        }
      }
      th {
        padding: 5px 10px 5px 10px;
        background: #f5f5f5;

        &:first-of-type {
          width: 50%;
        }
        &:nth-of-type(2) {
          width: 30%;
          text-align: right;
        }
      }
    }
    .van-sidebar {
      width: 100%;
    }
    .van-sidebar-item {
      padding: 10px;
    }
  }
  .title {
    @extend .content;
    border: 1px solid var(--basic-border-color);
  }
}
</style>